
import { useMusicPlayer } from '../../hooks/useMusicPlayer';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import MusicPlayer from '../../components/feature/MusicPlayer';
import HeroSection from './components/HeroSection';
import FeaturedPlaylists from './components/FeaturedPlaylists';
import TrendingTracks from './components/TrendingTracks';
import RecommendedArtists from './components/RecommendedArtists';
import RecentlyPlayed from './components/RecentlyPlayed';
import UploadCTA from './components/UploadCTA';

export default function HomePage() {
  const {
    currentTrack,
    isPlaying,
    currentTime,
    playTrack,
    togglePlayPause,
    playNext,
    playPrevious,
    seekTo
  } = useMusicPlayer();

  const handleTrackSelect = (track: any, trackList?: any[]) => {
    playTrack(track, trackList);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header onTrackSelect={handleTrackSelect} />
      
      <main className={currentTrack ? 'pb-20' : ''}>
        <HeroSection />
        <FeaturedPlaylists onTrackSelect={handleTrackSelect} />
        <TrendingTracks onTrackSelect={handleTrackSelect} />
        <RecommendedArtists />
        <RecentlyPlayed onTrackSelect={handleTrackSelect} />
        <UploadCTA />
      </main>

      <Footer />

      {currentTrack && (
        <MusicPlayer
          currentTrack={currentTrack}
          isPlaying={isPlaying}
          onPlayPause={togglePlayPause}
          onNext={playNext}
          onPrevious={playPrevious}
          onSeek={seekTo}
          currentTime={currentTime}
        />
      )}
    </div>
  );
}
